export const AttendanceReportApi = {
    heading:[
        {
            head:"SL"
        },
        {
            head:"ID"
        },
        {
            head:"Name"
        },
        {
            head:"Designation"
        },
        {
            head:"W.D"
        },
        {
            head:"Late"
        },
        {
            head:"Early Leave"
        },
        {
            head:"Absent Date & Day"
        },
        {
            head:"Deduciton For Late"
        },
        {
            head:"Deduction for Early Leave"
        },
        {
            head:"Leave Without Pay"
        },
        {
            head:"Total Deduction"
        },
        {
            head:"Total Payable"
        },
        {
            head:"Remark"
        },
    ],
    data:[
        {
            sl:1,
            id:1138,   
            name:"Shoumik", 
            designation:"Senior Developer", 
            wd:"t",
            late:"3",
            earlyleave:"2",
            absentdateandday:"02-06-2023 Monday",
            deductionforlate:900,
            deductionforearlyleave:450,
            leavewithoutpay:0,
            tottaldeduction:1350,
            totalpayable:1350,
            remark:"Good"
        },
       
      
        
     
       
    ]
}

